import { createContext, ReactElement, ReactNode, useContext } from 'react'

const ImportedInvoiceDrawerActionsContext = createContext<HTMLElement | null>(null)

interface ImportedInvoiceDrawerActionsProviderProps {
  actionsElement: HTMLElement | null
  children: ReactNode
}

/**
 * Shares the drawer header's actions slot with the content below it. An action that needs state
 * from deep inside the body — Approve needs the review form's validity — portals itself into the
 * slot instead of lifting that state above the `Drawer`, which would replay the drawer's opening
 * animation on every remount.
 */
export const ImportedInvoiceDrawerActionsProvider = ({
  actionsElement,
  children,
}: ImportedInvoiceDrawerActionsProviderProps): ReactElement => (
  <ImportedInvoiceDrawerActionsContext.Provider value={actionsElement}>
    {children}
  </ImportedInvoiceDrawerActionsContext.Provider>
)

/** `null` until the header has mounted the slot. */
export const useImportedInvoiceDrawerActionsElement = (): HTMLElement | null =>
  useContext(ImportedInvoiceDrawerActionsContext)
